<div class="sli-dialog-container">

  <!-- Header -->
  <div class="sli-dialog-header">
    <div class="sli-header-content">
      <div class="sli-header-icon">
        <i class="bi bi-person-plus-fill"></i>
      </div>
      <div class="sli-header-text">
        <h2>Share Legal Information<ng-container *ngIf="data.document.title || data.document.name"> - {{ data.document.title || data.document.name }}</ng-container></h2>
        <p>Share this legal information securely with your lawyers.</p>
      </div>
    </div>
    <button mat-icon-button (click)="onCancel()" class="sli-close-btn" aria-label="Close">
      <img src="assets/images/close-circle.svg" alt="Close">
    </button>
  </div>

  <!-- Search -->
  <div class="sli-search-container">
    <p class="sli-section-title">Select Lawyer(s)</p>
    <div class="sli-search-box">
      <i class="bi bi-search"></i>
      <input type="text"
             class="sli-search-input"
             placeholder="Search lawyers by name or firm..."
             [ngModel]="searchQuery"
             (ngModelChange)="onSearchChange($event)">
    </div>
  </div>

  <!-- Lawyer list -->
  <div class="sli-lawyer-list">

    <div *ngIf="loading" class="sli-state-message">
      Loading lawyers...
    </div>

    <div *ngIf="!loading && loadError" class="sli-state-message sli-error">
      Could not load your lawyers.
      <button type="button" class="sli-retry-link" (click)="loadLawyers()">Retry</button>
    </div>

    <ng-container *ngIf="!loading && !loadError">
      <div *ngIf="!filteredLawyers.length" class="sli-state-message">
        {{ lawyers.length ? 'No lawyers found' : 'No lawyers available to share with yet.' }}
      </div>

      <div *ngFor="let lawyer of filteredLawyers" class="sli-lawyer-card"
           [class.sli-inactive]="isInactive(lawyer)"
           [matTooltip]="isInactive(lawyer) ? inactiveTip(lawyer) : ''" matTooltipPosition="above">
        <div class="sli-avatar-container">
          <img *ngIf="hasValidAvatar(lawyer)"
               [src]="lawyer.avatar"
               alt="{{lawyer.name}} avatar"
               class="sli-avatar-image">
          <div *ngIf="!hasValidAvatar(lawyer)"
               class="sli-avatar"
               [style.background-color]="getAvatarColor(lawyer.id)"
               [title]="'No profile image available for ' + lawyer.name">
            {{ getInitial(lawyer.name) }}
          </div>
        </div>
        <div class="sli-lawyer-info">
          <div class="sli-lawyer-name">{{ lawyer.name }}</div>
          <div class="sli-lawyer-firm" *ngIf="lawyer.firmName">{{ lawyer.firmName }}</div>
        </div>
        <mat-checkbox
          [checked]="lawyer.selected"
          [disabled]="isInactive(lawyer)"
          (change)="toggleSelection(lawyer)"
          color="primary">
        </mat-checkbox>
      </div>
    </ng-container>
  </div>

  <!-- Actions -->
  <div class="sli-dialog-actions">
    <button mat-button (click)="onCancel()" class="sli-cancel-btn">Cancel</button>
    <button mat-flat-button
            color="primary"
            class="sli-next-btn"
            [disabled]="!hasSelection"
            (click)="onNext()">
      Next
    </button>
  </div>
</div>